export type NavChild = {
  label: string
  href: string
  exact?: boolean
}

export type NavItem = NavChild & {
  children?: NavChild[]
}

export const ENVIRONMENT_NAV: NavItem[] = [
  { label: 'Overview', href: '', exact: true },
  { label: 'Organizations', href: '/organizations' },
  { label: 'Logs', href: '/logs' },
  {
    label: 'Developers',
    href: '/developers',
    children: [
      { label: 'API keys', href: '/developers/api-keys' },
      { label: 'Endpoints', href: '/developers/endpoints' },
      { label: 'Webhooks', href: '/developers/webhooks' }
    ]
  }
]

export const WORKOS_MOVE_NAV: NavItem = { label: 'Moving from WorkOS', href: '/workos' }

export const TEAM_NAV: NavItem[] = [
  {
    label: 'Team',
    href: '/team',
    children: [
      { label: 'General', href: '/team', exact: true },
      { label: 'Members', href: '/team/members' },
      { label: 'Billing', href: '/team/billing' }
    ]
  }
]

export const ORGANIZATION_NAV: NavChild[][] = [
  [
    { label: 'Overview', href: '', exact: true },
    { label: 'Single sign-on', href: '/sso' },
    { label: 'Directory Sync', href: '/directory-sync' },
    { label: 'Logs', href: '/sign-ins' }
  ],
  [
    { label: 'Setup link', href: '/setup' },
    { label: 'Settings', href: '/settings' }
  ]
]
